export default __webpack_public_path__ + "static/media/image-chair-learn-w@3x.a712cbcd.png";